import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark pt-20 pb-10 px-6 border-t border-white/10" data-id="element-116">
      <div className="max-w-7xl mx-auto" data-id="element-117">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-118">
          {/* Brand Col */}
          <div className="flex flex-col items-start" data-id="element-119">
            <img src="https://cdn.magicpatterns.com/uploads/iTHV1zi5LbUMvL5bFz6T1i/pestco.webp" alt="Ultimate Pest Co Logo" className="h-20 w-20 object-contain animate-glow-pulse bg-black rounded-full mb-6" data-id="element-120" />
            <p className="font-barlow text-brand-gray text-sm max-w-xs" data-id="element-121">
              Honest, effective pest control for your home and business. We
              don't just treat problems — we eliminate them.
            </p>
          </div>

          {/* Services Links */}
          <div data-id="element-122">
            <h4 className="font-condensed uppercase text-white font-bold text-xl tracking-wider mb-6" data-id="element-123">
              Services
            </h4>
            <ul className="space-y-3 font-barlow text-brand-gray" data-id="element-124">
              <li data-id="element-125">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-126">
                  Ant Control
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-128">
                  Spider Treatment
                </a>
              </li>
              <li data-id="element-129">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-130">
                  Rodent Exclusion
                </a>
              </li>
              <li data-id="element-131">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-132">
                  Mosquito Defense
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-134">
                  Roach Elimination
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-135">
            <h4 className="font-condensed uppercase text-white font-bold text-xl tracking-wider mb-6" data-id="element-136">
              Company
            </h4>
            <ul className="space-y-3 font-barlow text-brand-gray" data-id="element-137">
              <li data-id="element-138">
                <a href="#about" className="hover:text-brand-green transition-colors" data-id="element-139">
                  About Us
                </a>
              </li>
              <li data-id="element-140">
                <a href="#how-it-works" className="hover:text-brand-green transition-colors" data-id="element-141">
                  How It Works
                </a>
              </li>
              <li data-id="element-142">
                <a href="#reviews" className="hover:text-brand-green transition-colors" data-id="element-143">
                  Reviews
                </a>
              </li>
              <li data-id="element-144">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-145">
                  Contact
                </a>
              </li>
              <li data-id="element-146">
                <a href="#" className="hover:text-brand-green transition-colors" data-id="element-147">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-148">
            <h4 className="font-condensed uppercase text-white font-bold text-xl tracking-wider mb-6" data-id="element-149">
              Contact Us
            </h4>
            <ul className="space-y-4 font-barlow text-brand-gray" data-id="element-150">
              <li className="flex flex-col" data-id="element-151">
                <span className="text-white/50 text-xs uppercase tracking-wider mb-1" data-id="element-152">
                  Phone
                </span>
                <a href="tel:555-0123" className="text-white hover:text-brand-green transition-colors text-lg font-medium" data-id="element-153">
                  (555) 123-4567
                </a>
              </li>
              <li className="flex flex-col" data-id="element-154">
                <span className="text-white/50 text-xs uppercase tracking-wider mb-1" data-id="element-155">
                  Email
                </span>
                <a href="mailto:hello@ultimatepest.com" className="text-white hover:text-brand-green transition-colors" data-id="element-156">
                  hello@ultimatepest.com
                </a>
              </li>
              <li className="flex flex-col" data-id="element-157">
                <span className="text-white/50 text-xs uppercase tracking-wider mb-1" data-id="element-158">
                  Hours
                </span>
                <span className="text-white" data-id="element-159">
                  Mon-Fri: 8am - 6pm
                  <br data-id="element-160" />
                  Sat: 9am - 2pm
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-161">
          <p className="font-barlow text-brand-gray text-sm" data-id="element-162">
            &copy; {new Date().getFullYear()} Ultimate Pest Co. All rights
            reserved.
          </p>
          <p className="font-condensed uppercase text-brand-green tracking-widest text-sm font-semibold" data-id="element-163">
            Locally Owned & Operated
          </p>
        </div>
      </div>
    </footer>;
}